<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" class="centerPlace">
        <v-card elevation="12" class="rounded-xl auth-glass-card">
          <v-toolbar color="transparent" flat height="64" class="px-2">
            <v-toolbar-title class="font-weight-bold">
              <div class="d-flex align-center">
                <v-img
                  :src="logo"
                  width="40"
                  height="40"
                  max-width="40"
                  class="mr-2 flex-grow-0 flex-shrink-0"
                />
                <span>Pâtes au jambon</span>
              </div>
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <v-col cols="12" align-self="center" class="text-center">
                <v-btn
                  color="white"
                  elevation="1"
                  block
                  :disabled="!gInit"
                  @click="loginWithGoogle"
                >
                  <v-icon class="mr-2" :color="'#' + changingColor">
                    mdi-google
                  </v-icon>
                  Connexion avec Google
                </v-btn>
              </v-col>
            </v-row>
            <v-row align="center" class="my-2">
              <v-col>
                <v-divider />
              </v-col>
              <v-col cols="auto" class="pa-0 text-center text-caption text-medium-emphasis">
                <span class="mx-2 font-weight-medium">OU</span>
              </v-col>
              <v-col>
                <v-divider />
              </v-col>
            </v-row>
            <v-alert
              v-if="specialMessage"
              border-color
              color="primary"
              border="start"
              elevation="2"
              class="mb-3"
            >
              {{ specialMessage }}
            </v-alert>
            <v-row dense>
              <v-col cols="12">
                <v-form>
                  <div class="mb-1 px-1">
                    <label for="username" class="text-body-2 font-weight-medium">Email</label>
                  </div>
                  <v-text-field
                    id="username"
                    v-model="username"
                    name="username"
                    placeholder="exemple@email.com"
                    prepend-inner-icon="mdi-account"
                    type="text"
                    autocomplete="username"
                    class="mb-3"
                    bg-color="background"
                    @keydown="keyCheck"
                  />

                  <div class="d-flex justify-space-between align-center mb-1 px-1">
                    <label for="password" class="text-body-2 font-weight-medium">Mot de passe</label>
                    <router-link
                      to="/forgotten-password"
                      class="text-caption text-primary text-decoration-none font-weight-medium link-hover"
                    >
                      Mot de passe oublié ?
                    </router-link>
                  </div>

                  <v-text-field
                    id="password"
                    v-model="password"
                    name="password"
                    placeholder="Votre mot de passe"
                    prepend-inner-icon="mdi-lock"
                    :type="showPassword ? 'text' : 'password'"
                    autocomplete="current-password"
                    :append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    bg-color="background"
                    @click:append-inner="showPassword = !showPassword"
                    @keydown="keyCheck"
                  />
                </v-form>
              </v-col>
            </v-row>
            <v-row dense class="mt-2 text-center">
              <v-col cols="12">
                <v-btn
                  color="primary"
                  size="large"
                  block
                  :loading="connexionLoading"
                  @click="login"
                >
                  Se connecter
                </v-btn>
              </v-col>
            </v-row>
            <v-divider class="my-5" />
            <v-row class="text-center">
              <v-col cols="12" class="text-body-2 text-medium-emphasis">
                Pas de compte ?
                <router-link
                  to="/sign-up"
                  class="text-primary font-weight-bold text-decoration-none ml-1 link-hover"
                >
                  Créer un compte
                </router-link>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { useRepo } from 'pinia-orm'
import { UserRepo } from "@/models/User"
import shared from "@/shared"
import { googleAuthCodeLogin } from "vue3-google-login"
import logoImg from '@/assets/logo.png'

export default {
  name: "LoginView",
  beforeRouteEnter: function (to, from, next) {
    document.body.classList.add("login")
    next()
  },
  beforeRouteLeave: function (to, from, next) {
    document.body.classList.remove("login")
    next()
  },
  data: () => ({
    publicPath: import.meta.env.BASE_URL,
    username: "",
    password: "",
    specialMessage: "",
    messages: {
      validatedAccount:
        "Votre compte a été activé. Vous pouvez maintenant vous connecter.",
    },
    showPassword: false,
    changingColor: "",
    changingColorInterval: null,
    connexionLoading: false,
    gInit: false,
    logo: logoImg
  }),
  mounted() {
    const messageCode = shared.getUrlVars()["message"]
    if (messageCode) {
      this.specialMessage = this.messages[messageCode] || ""
    }

    // Blue, red, yellow, green
    const gColor = ["4285F4", "DB4437", "F4B400", "0F9D58"]
    this.changingColorInterval = setInterval(() => {
      const prevColorIndex = gColor.indexOf(this.changingColor)
      this.changingColor = !this.changingColor
        ? gColor[0]
        : gColor[(prevColorIndex + 1) % 4]
    }, 2000)

    this.waitForInit()
  },
  beforeUnmount() {
    clearInterval(this.changingColorInterval)
  },
  methods: {
    login: async function () {
      this.connexionLoading = true
      try {
        await useRepo(UserRepo).$login(this.username, this.password)
        this.$root.$emit("login")
        this.$router.push("/").catch((err) => {})
      } catch (e) {
        //debugger;
      }
      this.connexionLoading = false
    },
    loginWithGoogle: async function () {
      try {
        this.connexionLoading = true
        const authCode = await googleAuthCodeLogin()
        await useRepo(UserRepo).$loginWithGoogle(authCode)
        this.$root.$emit("login")
        this.$router.push("/").catch((err) => {})
      } catch (error) {
        //debugger;
        // On fail do something
      }
      this.connexionLoading = false
    },
    waitForInit() {
      if (!this.gInit) {
        this.gInit = true
      } else {
        setTimeout(() => {
          this.waitForInit()
        }, 1000)
      }
    },
    keyCheck(e) {
      if (e.keyCode === 13) {
        this.login()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.centerPlace {
  max-width: 480px;
}

.link-hover {
  transition: opacity 0.2s ease;
  &:hover {
    text-decoration: underline !important;
    opacity: 0.85;
  }
}
</style>